import ContactsListPage from "./ContactsListPage";

export default function ContactsCompanies() {
  return <ContactsListPage kind="company" />;
}
